import React, { useState } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import { SubmitButton, CancelButton } from '../../Res/BaseButton';
import { RespDepartment } from '../../../../item/ItemDepartment';
import { AdminDepartmentContent } from './AdminDepartmentContent';
import { ContentBox } from '../../Content/ContentBox';

export function AdminDepartmentAdd ({id, list, cancel}) {
  const[companyId] = useState(id)
  const[departmentName, setDepartmentName] = useState("")
  const[managerDepartmentId, setManagerDepartmentId] = useState("")

  var title = '部門 - 新增'
  var title_tools = ''
  var content = <AdminDepartmentContent list={list} sn={setDepartmentName} sm={setManagerDepartmentId} />
  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <SubmitButton action={toAdd} isRight={true} />
        <CancelButton action={cancel} isRight={true} />
      </div>
    </div>

  function toAdd(){
    console.log(departmentName)
    if(departmentName !== ""){
      var mRespDepartment = new RespDepartment({
        companyId,
        departmentName,
        managerDepartmentId
      })
      apiCompany.departmentAdd({ 
        mRespDepartment, 
        success: (obj)=>{
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function() {
            setDepartmentName("")
            setManagerDepartmentId("")
            cancel();
            //window.history.replace("/ManagerList");
          })
        },
        failure: ()=>{

        }
      })
    }else{
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '部門名稱 不得為空',
      })
    }
  }

  return (    
    <ContentBox title={title} title_tools={title_tools} content={content} footer={footer}  hasDrawer={true} />
  )
}

